export const request = {
  mode: "ko",
  request: {
    title: "셀디 서비스 신청 문의",
    company: "회사명",
    companyPlaceholder: "회사명을 입력해주세요",
    name: "이름",
    namePlaceholder: "이름을 입력해주세요",
    phoneNumber: "연락처",
    email: "이메일 주소",
    site: "웹 사이트",
    agreeTitle: "정보수신동의",
    required: "필수",
    requiredDescription: "개인정보 수징 및 이용동의",
    notRequired: "선택",
    notRequiredDescription: "소개서, 뉴스레터 등 셀디 정보 수신에 동의",
    button: "셀디 신청하기",
  },
};
